module.exports = __webpack_public_path__ + "static/media/shiftshave-replacement-blade-5.b3b66b71.png";